{
	"address": "Address",
	"addressRequired": "Field is required",
	"allowedFiles": "Allowed file extensions: png, jpg, jpeg, gif, bmp, doc, docx, txt og pdf",
	"choose": "Choose",
	"chooseCountry": "Choose country",
	"choosePostbox": "Choose parcel locker",
	"city": "City",
	"dragFilesHere": "Drag your files here",
	"electronicId": "Electronic id",
	"email": "E-mail",
	"emailNotValid": "Email is not valid",
	"emailRequired": "Field is required",
	"error": "Error",
	"errorMessage": "There was an error. Plesae try again later.",
	"fileNotallowed": "File ending not allowed or the file size exceeds 25mb.",
	"file-min": "Have to add a document",
	"homeDelivery": "Order home delivery",
	"homeDeliveryInfo": "We will give you a 30 minute window for the estimated delivery time.",
	"infoAboutSender": "Info about sender",
	"maxNumbers": "Field has reached maximum limit of numbers",
	"maxText": "Field has reached maximum limit of characters",
	"minNumbers": "Field has not reached minimum limit of numbers",
	"minText": "Field has not reached minimum limit of characters",
	"name": "Name",
	"nameRequired": "Field is required",
	"newsletterCompanies": "Get updates for companies",
	"newsletterShops": "Get updates for shops",
	"newsletterIndividuals": "Get updates for individuals",
	"newsletterRequired": "Must select atleast one list to follow",
	"next": "Next step",
	"onLoad": "...Loading",
	"onlyNumbers": "Only numbers allowed",
	"open-pdf": "If the PDF doesn't open please click the link to do it manually",
	"open-pdf-link": "Open PDF link",
	"paymentInfo": "Bank information",
	"phone": "Phone",
	"phoneMax": "Phone number has reached maximum limit of characters",
	"phoneMin": "Phone number contains to few charaters",
	"phoneNotValid": "Phone number not valid",
	"phoneRequired": "Field is required",
	"postboxRequired": "Field is required",
	"print-pdf": "Print out the pdf and include with the package to the post office",
	"required": "Field is required",
	"signUp": "Sign up",
	"ssn": "Social ID",
	"ssn-valid": "Social ID is not valid",
	"submit": "Submit",
	"success": "Success",
	"successMessage": "Form has been submitted.",
	"successMessagePostboxDelivery1": "In order to complete the request, transfer 990 kr. to the following account:",
	"successMessagePostboxDelivery2": "Kt. 7012966139, Rnr. 116-26-6666",
	"successMessagePostboxDelivery3": "Important: Send a receipt to posturinn@posturinn.is and include the package tracking number.",
	"successMessagePostlist": "Thank you for joining our newsletter - great to have you on board!",
	"thereWasAnError": "There was an error",
	"thereWasAnErrorText": "We have sent an email to our system manager who will look into the issue",
	"trackingnumber": "Trackingnumber",
	"trackingnumberWrong": "Trackingnumber format incorrect",
	"trackingnumberForeignFormat": "Tracking number has to start with C or R to be an international parcel.",
	"trackingnumberMax": "Trackingnumber can be a maximum of 35 characters",
	"trackingnumberMin": "Trackingnumber cannot have less than 8 characters",
	"trackingnumberRequired": "Field is required",
	"trackingnumberNotFound": "Trackingnumber not found",
	"trackingnumberNotOutbound": "You can only inquire about exported shipment",
	"zip": "Zip code",
	"zipRequired": "Field is required",
	"tooLong": "Too many characters",
	"must-be-7": "Length must be 7",
	"chatAuth": "Chat authentication",
	"chatAuthInfo": "Please authenticate with electronic identification so we can assist you further",
	"enterCommas": "You can register more then one tracking number with a comma, e.g. CD123456789CD,CD123456789CD"
}